import { customElement, state } from 'lit/decorators.js'
import { html, LitElement, nothing } from 'lit'

import { SEARCH_PRODUCTS_STORE, SearchProductsStore } from 'components/discovery/shared/search/stores/search-products-store.js'
import { PaginationOnNavigateEvent } from 'components/shared/pagination/pagination.js'
import { SearchResults } from 'components/discovery/shared/search/typing/search-results.js'
import { createEffect } from '@cloudsuite/mosaic-shared/scripts/signals.js'
import { inject } from '@cloudsuite/mosaic-shared/scripts/dependency-injection.js'


@customElement('csc-product-grid-pagination')
export class CSCProductGridPagination extends LitElement {

  @inject(SEARCH_PRODUCTS_STORE)
  private filterWizardStore!: SearchProductsStore

  @state()
  searchResults!: SearchResults

  @state()
  isLoading!: boolean

  handlePageSelect(event: PaginationOnNavigateEvent) {
    this.filterWizardStore.search(event.pageLink)
  }

  constructor() {
    super()

    createEffect(() => {
      this.searchResults = this.filterWizardStore.searchResults()
      this.isLoading = this.filterWizardStore.searchIsLoading()
    })
  }

  override render() {
    return this.searchResults.paginator ? html`
      <csc-pagination 
        current-page="${this.searchResults.paginator.page}"
        number-of-pages="${this.searchResults.paginator.num_pages}"
        first-link="${this.searchResults.paginator.first_page_search_link}"
        prev-link="${this.searchResults.paginator.prev_page_search_link}"
        next-link="${this.searchResults.paginator.next_page_search_link}"
        last-link="${this.searchResults.paginator.last_page_search_link}"
        @pagination-on-navigate="${this.handlePageSelect}"
      ></csc-pagination>
    ` : nothing
  }
}
